import React from 'react';
import '../App.css';

const FooterComponent: React.FC = () => {
  return (
    <>
      <div className='footer'>
        <div style={{ fontSize: 12, color: '#FFFFFF' }}>©︎conoc</div>
      </div>
    </>
  );
};
export default FooterComponent;
